/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PeerSrmInfo { 
    /**
     * Unique identifier (UUID) of the peer SRM
     */
    id?: string;
    /**
     * Version of the peer SRM
     */
    version?: string;
    /**
     * Display name of the peer SRM
     */
    name?: string;
    /**
     * Organization identifier
     */
    orgId?: string;
    /**
     * SRM license mode.  Possible values include: - legacy_unknown - legacy_eval - legacy_standard - legacy_essentials - legacy_enterprise - legacy_cloud - legacy_term - cloud_trial - cloud_subscription - cloud_offline_subscription 
     */
    licenseType?: string;
    /**
     * Associated vCenter display name
     */
    vcenterName?: string;
    /**
     * Associated vCenter instance UUID
     */
    vcenterUuid?: string;
}

